import CategoryPagePlaceHolder from "../page-placeholder/CategoryPagePlaceHolder";
import CMSPagePlaceHolder from "../page-placeholder/CMSPagePlaceHolder";
import HomePagePlaceHolder from "../page-placeholder/HomePagePlaceHolder";
import MakeModelPagePlaceHolder from "../page-placeholder/MakeModelPagePlaceHolder";
import ProductPagePlaceHolder from "../page-placeholder/ProductPagePlaceHolder";

export const PLACEHOLDER_PAGE_TYPE = {
  CATEGORY_PAGE: "category",
  PRODUCT_PAGE: "product",
  CMS_PAGE: "cms",
  MAKE_MODEL: "make-model",
  HOME_PAGE: "Home-page",
};

function PagePlaceholder(props: any) {
  const { pageType } = props;
  let render;
  switch (pageType) {
  case PLACEHOLDER_PAGE_TYPE.CATEGORY_PAGE:
    render = <CategoryPagePlaceHolder />;
    break;
  case PLACEHOLDER_PAGE_TYPE.PRODUCT_PAGE:
    render = <ProductPagePlaceHolder />;
    break;
  case PLACEHOLDER_PAGE_TYPE.CMS_PAGE:
    render = <CMSPagePlaceHolder />;
    break;
  case PLACEHOLDER_PAGE_TYPE.MAKE_MODEL:
    render = <MakeModelPagePlaceHolder />;
    break;
  case PLACEHOLDER_PAGE_TYPE.HOME_PAGE:
    render = <HomePagePlaceHolder />;
    break;
  default:
    render = "TODO";
  }
  return render;
}

export default PagePlaceholder;
